/**
 * BeBobi pre-checkout step: every "checkout" action in the storefront goes
 * to /pages/dostawa first (delivery choice, InPost locker picker), and that
 * page navigates to /checkout itself.
 *
 * Loaded from layout/theme.liquid on every page (plain script, defer).
 *
 * Horizon has exactly one checkout trigger: the <button name="checkout"
 * form="cart-form"> rendered by snippets/cart-summary.liquid for both the
 * cart page and the drawer. It lives OUTSIDE the form and reaches it via the
 * form attribute, so both the click and the resulting submit are intercepted
 * in the capture phase, before Horizon's own handlers see them.
 *
 * Shopify's accelerated buttons (PayPal, Google Pay) in .cart__ctas cannot
 * be intercepted - they go straight to checkout - so they are hidden in the
 * cart contexts. Product-page dynamic checkout buttons are left alone: the
 * Progus embed hides those.
 */
(function () {
  'use strict';

  var path = window.location.pathname;
  /* never on the delivery step itself, in checkout, or on order pages */
  if (/\/pages\/dostawa(\/|$)/.test(path)) return;
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkouts?(\/|$)/i.test(path)) return;
  if (/\/thank_you(\/|$)|\/orders\//.test(path)) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var target = root.replace(/\/?$/, '/') + 'pages/dostawa';

  var TRIGGER = 'button[name="checkout"], a[href*="/checkout"]';
  var SKIP = '[data-bb-skip-redirect], shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart';

  function redirect(evt, why) {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    if (window.console && console.debug) console.debug('[bb-redirect] ' + why + ' -> ' + target);
    window.location.assign(target);
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart') === -1) return;
    var submitter = evt.submitter;
    if (!submitter || submitter.getAttribute('name') !== 'checkout') return;
    if (submitter.closest && submitter.closest(SKIP)) return;
    redirect(evt, 'cart form submit');
  }, true);

  document.addEventListener('click', function (evt) {
    var el = evt.target && evt.target.closest ? evt.target.closest(TRIGGER) : null;
    if (!el) return;
    if (el.closest(SKIP)) return;
    redirect(evt, el.tagName === 'A' ? 'checkout link' : 'checkout button');
  }, true);

  /* accelerated buttons in the cart page + drawer bypass the step: hide them */
  var style = document.createElement('style');
  style.setAttribute('data-bb-checkout-redirect', '');
  style.textContent = '.cart__ctas .additional-checkout-buttons{display:none!important}';
  (document.head || document.documentElement).appendChild(style);
})();
